<app-dialog-container>
  <h1 mat-dialog-title>INFORME O MOTIVO</h1>
  <div mat-dialog-content class="dialogContent">
    <!-- MOTIVO -->
    <mat-form-field class="input" appearance="outline">
      <mat-label>MOTIVO</mat-label>
      <input
        cdkFocusInitial
        matInput
        class="uppercase"
        [(ngModel)]="element.updateReason"
      />
    </mat-form-field>
  </div>

  <div mat-dialog-actions align="end">
    <button mat-button mat-dialog-close (click)="clickNo()">SAIR</button>
    <button mat-button cdkFocusInitial (click)="clickOk()">CONTINUAR</button>
  </div>
</app-dialog-container>
